import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_HOLIDAY_LIST_SUCCESS,
    GET_HOLIDAY_LIST_ERROR,
    SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS,
    SET_HOLIDAY_LIST_AND_UPCOMING_BUSINESS_DAYS_FOR_REQUEST_DELIVERY_DATE
} from '../actions';
import { SET_HOLIDAY_LIST_AND_UPCOMING_7_BUSINESS_DAYS_FOR_CONSIGNMENT_ADD } from 'src/pages/consignmentAdd/redux/actions';

export default function* getHolidayList(action) {
    //  const  {surgeryDeliveryDateLeadTime}  =
    //     yield select((state) =>
    //         ({ surgeryDeliveryDateLeadTime: state.loginReducer.surgeryDeliveryDateLeadTime, }));
        
    const { date, calculateLastThreeBusinessDays, leadTime } = action.payload;
    if (calculateLastThreeBusinessDays !== true) {

        if (calculateLastThreeBusinessDays === 'kb') {
              let url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/calendar/holidays?date=${encodeURIComponent(date)}`;
            try {
                const result = yield axios
                    .get(url)
                    .then((response) => response.data.holidaystatus);
                yield put({
                    type: SET_HOLIDAY_LIST_AND_UPCOMING_7_BUSINESS_DAYS_FOR_CONSIGNMENT_ADD,
                    payload: { result: result}
                });
            
            } catch (e) {
                logUiErrorToBackend(e, {
                    apiEndPoint: url,
                    requestPayload: action.payload
                });
                yield put({
                    type: GET_HOLIDAY_LIST_ERROR,
                    payload: errorHandler('503'),
                });
            }
        }
        
        else {

       
            let url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/calendar/holidays?date=${date}`;
            try {
                const result = yield axios
                    .get(url)
                    .then((response) => response.data.holidaystatus);
                yield put({
                    type: SET_HOLIDAY_LIST_AND_UPCOMING_BUSINESS_DAYS_FOR_REQUEST_DELIVERY_DATE,
                    payload: { result: result, leadTime: leadTime }
                });
            
            } catch (e) {
                logUiErrorToBackend(e, {
                    apiEndPoint: url,
                    requestPayload: action.payload
                });
                yield put({
                    type: GET_HOLIDAY_LIST_ERROR,
                    payload: errorHandler('503'),
                });
            }
        }
    }
    else {
        let url = `/occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/calendar/holidays?date=${date}`;
        try {
            const result = yield axios
                .get(url)
                .then((response) => response.data.holidaystatus);

            if (calculateLastThreeBusinessDays) {
                yield put({
                    type: SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS,
                    payload: result,
                });
            } else {
                yield put({
                    type: GET_HOLIDAY_LIST_SUCCESS,
                    payload: result[0].isHoliday,
                });
            }
        
        } catch (e) {
            logUiErrorToBackend(e, {
                apiEndPoint: url,
                requestPayload: action.payload
            });
            yield put({
                type: GET_HOLIDAY_LIST_ERROR,
                payload: errorHandler('503'),
            });
        }
    }
}
